/** CRA can still inline `REACT_APP_PANEL_*` at build time; Cloud Run prefers `window.__PANEL_ENV__` from `/runtime-config.js` (see deploy/docker-entrypoint.sh).
 * `PANEL_SOCKET_ORIGIN`: HTTP(S) origin of antbuildz-new-backend-v1 (same host as API; Socket.IO uses path `/users` in `src/utils/socket.services.js`). */
function panelUrlFromEnv(envName, fallback) {
    const raw = process.env[envName];
    if (raw == null || String(raw).trim() === "") return fallback;
    const s = String(raw).trim();
    return s.endsWith("/") ? s : `${s}/`;
}

function normalizePanelAssetsUrl(raw) {
    if (raw == null || String(raw).trim() === "") return null;
    let s = String(raw).trim().replace(/\/+$/, "");
    // GSM R2_PUBLIC_URL is the bucket root; panel builds URLs as {base}images/...
    if (/\.r2\.dev$/i.test(s) && !/\/assets$/i.test(s)) {
        s = `${s}/assets`;
    }
    return `${s}/`;
}

function panelUrlFromRuntime(runtimeKey, envName, fallback) {
    if (typeof window !== "undefined" && window.__PANEL_ENV__ && window.__PANEL_ENV__[runtimeKey] != null) {
        const r = String(window.__PANEL_ENV__[runtimeKey]).trim();
        if (r) {
            if (runtimeKey === "PANEL_ASSETS_DOMAIN") {
                const normalized = normalizePanelAssetsUrl(r);
                if (normalized) return normalized;
            }
            return r.endsWith("/") ? r : `${r}/`;
        }
    }
    const fromEnv = panelUrlFromEnv(envName, fallback);
    if (envName === "REACT_APP_PANEL_ASSETS_DOMAIN") {
        return normalizePanelAssetsUrl(fromEnv) || fromEnv;
    }
    return fromEnv;
}

const defaultPanelApiBase = "https://antbuildz.com/antbuildz/";
const defaultPanelSocket = "https://antbuildz.com/";
const defaultPanelAssets = "https://pub-c213f9a11cb74fbc95b439b04d3e21dc.r2.dev/assets/";

const panelApiBase = panelUrlFromRuntime("PANEL_API_BASE", "REACT_APP_PANEL_API_BASE", defaultPanelApiBase);
const panelSocket = panelUrlFromRuntime("PANEL_SOCKET_ORIGIN", "REACT_APP_PANEL_SOCKET_ORIGIN", defaultPanelSocket);
const panelAssets = panelUrlFromRuntime("PANEL_ASSETS_DOMAIN", "REACT_APP_PANEL_ASSETS_DOMAIN", defaultPanelAssets);

const siteConfig = {
    languages: ["en"],
    // languages: ["fa"],

    defaultLng: 'en',
    dontShowUrlForDefaultLng: true,
    forceUrl: false,


    showCart: true,
    showProfile: true,
    showLanguage: true,
    showDeliveryCalcText: false,
    showSmallHeaders: false,


    // rootDomain: 'http://localhost:9921/antbuildz/',
    // domain: 'http://localhost:9921/antbuildz/',
    // assetsDomain: 'https://cdn2.antbuildz.com/',
    // // assetsDomain: 'http://localhost:9921/antbuildz/assets',
    // socketDomain: "https://test2.antbuildz.com/",

    // rootDomain: 'https://test2.antbuildz.com/antbuildz/',
    // domain: 'https://test2.antbuildz.com/antbuildz/',
    // assetsDomain: 'https://cdn2.antbuildz.com/',
    // socketDomain: "https://test2.antbuildz.com/",
    
    // rootDomain: 'https://develop2.antbuildz.com/antbuildz/',
    // domain: 'https://develop2.antbuildz.com/antbuildz/',
    // assetsDomain: 'https://cdn2.antbuildz.com/',
    // socketDomain: "https://develop2.antbuildz.com/",

    rootDomain: panelApiBase,
    domain: panelApiBase,
    assetsDomain: panelAssets,
    socketDomain: panelSocket,


    // rootDomain: 'https://test2.antbuildz.com/antbuildz/',
    // domain: 'https://test2.antbuildz.com/antbuildz/',
    // assetsDomain: 'https://cdn2.antbuildz.com/',
    // socketDomain: "https://test2.antbuildz.com/",

    // rootDomain: 'https://test2.antbuildz.com/antbuildz/',
    // domain: 'https://test2.antbuildz.com/antbuildz/',
    // assetsDomain: 'https://cdn.antbuildz.com/images/',
    // assetsMainDomain: 'https://cdn.antbuildz.com/',





    // rootDomain: 'http://127.0.0.1:9921/antbuildz/',
    // domain: 'http://127.0.0.1:9921/antbuildz/',
    // // assetsDomain: 'http://127.0.0.1:9921/antbuildz/assets',
    // assetsDomain: 'https://cdn2.antbuildz.com/',
    // socketDomain: "http://127.0.0.1:9902/",

    // rootDomain: 'https://test.antbuildz.com/antbuildz/',
    // domain: 'https://test.antbuildz.com/antbuildz/',
    // assetsDomain: 'https://cdntest.antbuildz.com/',
    // socketDomain: "https://test.antbuildz.com/",

    // rootDomain: 'https://antbuildz.com/antbuilznew/',
    // domain: 'https://antbuildz.com/antbuilznew/',
    // assetsDomain: 'https://cdn.antbuildz.com/',
    // socketDomain: "https://antbuildz.com/antbuilznew/",



    // rootDomain: 'https://antbuildz.com/antbuilznewtest/',
    // domain: 'https://antbuildz.com/antbuilznewtest/',
    // assetsDomain: 'https://antbuildz.com/',
    // socketDomain: "https://www.antbuildz.com/",

    // rootDomain: 'https://antbuildz.com/antbuilztest/',
    // domain: 'https://antbuildz.com/antbuilztest/',
    // assetsDomain: 'https://cdn.antbuildz.com/',
    // socketDomain: "https://www.antbuildz.com/",

    // rootDomain: 'http://iotsmile.com/',
    // domain: 'http://iotsmile.com/iot/',
    // assetsDomain: 'http://iotsmile.com/assets/',
    // socketDomain: "http://socket.iotsmile.com/",

    name: 'Antbuildz.com',
    siteName: 'Antbuildz.com',
    phone: '021-XXXX XXXX',
    instagram: 'https://instagram.com/anp-co',
    email: 'test@gmail.com',
    facebook: '',
}

const siteTheme = {


    logo: '/images/logo-a.png',
    logo_s: '/images/logo_s.png',
    // invertLogo: true,


    themeColors: { headerBack: '#f2f7f8', headerFont: '#000000' },
    // themeColors: { headerBack: '#46196f', headerFont: '#ffffff' },
    // themeColors: { headerBack: '#000000', headerFont: '#ffffff' },



    backgroundColors: { normal: '#e2e8ea', plus: '#ee5050', luxury: '#101010', custom: '#d3b564' },
    colors: { normal: '#202020', plus: '#fff', luxury: '#fff', custom: '#101010' },
}

const languagesInfo = {
    // en: {
    //     shortName: 'en',
    //     direction: 'ltr',
    //     name: 'English',
    //     icon: ''
    // },
    ch: {
        shortName: 'ch',
        direction: 'ltr',
        name: 'Chinese',
        icon: ''
    },
    ma: {
        shortName: 'ma',
        direction: 'ltr',
        name: 'Malay',
        icon: ''
    },
}
const languagesInfoTranslate = {
    ma: {
        shortName: 'ma',
        direction: 'ltr',
        name: 'Bahasa Melayu',
        englishName: 'Malay',
        icon: ''
      },
      es: {
        shortName: 'es',
        direction: 'ltr',
        name: 'Español',
        englishName: 'Spanish',
        icon: ''
      },
      zh: {
        shortName: 'zh',
        direction: 'ltr',
        name: '繁體中文',
        englishName: 'Chinese (Traditional)',
        icon: ''
      },
      ch: {
        shortName: 'ch',
        direction: 'ltr',
        name: '简体中文',
        englishName: 'Chinese (Simplified)',
        icon: ''
      },
      th: {
        shortName: 'th',
        direction: 'ltr',
        name: 'ภาษาไทย',
        englishName: 'Thai',
        icon: ''
      },
      tr: {
        shortName: 'tr',
        direction: 'ltr',
        name: 'Türkçe',
        englishName: 'Turkish',
        icon: ''
      },
      ar: {
        shortName: 'ar',
        direction: 'rtl',
        name: 'العربية',
        englishName: 'Arabic',
        icon: ''
      },
      ja: {
        shortName: 'ja',
        direction: 'ltr',
        name: '日本語',
        englishName: 'Japanese',
        icon: ''
      },
      ko: {
        shortName: 'ko',
        direction: 'ltr',
        name: '한국어',
        englishName: 'Korean',
        icon: ''
      },
      id: {
        shortName: 'id',
        direction: 'ltr',
        name: 'Bahasa Indonesia',
        englishName: 'Indonesian',
        icon: ''
      },
      fr: {
        shortName: 'fr',
        direction: 'ltr',
        name: 'Français',
        englishName: 'French',
        icon: ''
      },
      de: {
        shortName: 'de',
        direction: 'ltr',
        name: 'Deutsch',
        englishName: 'German',
        icon: ''
      },
      pt: {
        shortName: 'pt',
        direction: 'ltr',
        name: 'Português',
        englishName: 'Portuguese',
        icon: ''
      },
      hi: {
        shortName: 'hi',
        direction: 'ltr',
        name: 'हिन्दी',
        englishName: 'Hindi',
        icon: ''
      },
      ru: {
        shortName: 'ru',
        direction: 'ltr',
        name: 'Русский',
        englishName: 'Russian',
        icon: ''
      },
      vi: {
        shortName: 'vi',
        direction: 'ltr',
        name: 'Tiếng Việt',
        englishName: 'Vietnamese',
        icon: ''
      },
      it: {
        shortName: 'it',
        direction: 'ltr',
        name: 'Italiano',
        englishName: 'Italian',
        icon: ''
      },
      sv: {
        shortName: 'sv',
        direction: 'ltr',
        name: 'Svenska',
        englishName: 'Swedish',
        icon: ''
      },
      nl: {
        shortName: 'nl',
        direction: 'ltr',
        name: 'Nederlands',
        englishName: 'Dutch',
        icon: ''
      },
      ta: {
        shortName: 'ta',
        direction: 'ltr',
        name: 'தமிழ்',
        englishName: 'Tamil',
        icon: ''
      }
};

let apisList = {


    getCategories: { route: 'categories/categoriesGetAllPanel', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    categoriesGetAllForWiki: { route: 'categories/categoriesGetAllForWiki', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addCategory: { route: 'categories/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeCategory: { route: 'categories/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getBlogs: { route: 'blogs/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addBlog: { route: 'blogs/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeBlog: { route: 'blogs/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getResources: { route: 'resources/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    importAiWebsiteContent: { route: 'resources/importAiWebsiteContent', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    reviveAiData: { route: 'resources/reviveAiData', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addResource: { route: 'resources/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeResource: { route: 'resources/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getDemoRequests: { route: 'demoRequests/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneDemoRequest: { route: 'demoRequests/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addDemoRequest: { route: 'demoRequests/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeDemoRequest: { route: 'demoRequests/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    submitDemoRequest: { route: 'demoRequests/submit', server: 'yc', hashMethod: '', params: [], auth: '', flexibleParams: true },


    getRentals: { route: 'rentals/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneRental: { route: 'rentals/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addRental: { route: 'rentals/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeRental: { route: 'rentals/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    extendRentalTime: { route: 'rentals/extendTime', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    getFinancials: { route: 'financial/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneFinancial: { route: 'financial/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addFinancial: { route: 'financial/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeFinancial: { route: 'financial/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    getWikis: { route: 'wikis/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addWiki: { route: 'wikis/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeWiki: { route: 'wikis/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getAutoGens: { route: 'autoGens/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addAutoGen: { route: 'autoGens/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeAutoGen: { route: 'autoGens/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getEquipments: { route: 'equipments/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getEquipments: { route: 'equipments/findDuplicateEquipmentIds', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getEquipments: { route: 'equipments/getAllNoCountry', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    updateRentalSellId: { route: 'equipments/updateRentalSellId', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneEquipment: { route: 'equipments/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addEquipment: { route: 'equipments/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeEquipment: { route: 'equipments/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    getBrands: { route: 'brands/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneBrand: { route: 'brands/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addBrand: { route: 'brands/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeBrand: { route: 'brands/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
        getSubscriptionPlans: { route: 'subscriptionPlans/getAllPanel', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        getAiWebsitePublicationPreview: { route: 'subscriptionPlans/getAiWebsitePublicationPreview', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        publishAiWebsitePlans: { route: 'subscriptionPlans/publishAiWebsitePlans', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        publishIndividualSubscriptionPlan: { route: 'subscriptionPlans/publishIndividualPlan', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        getOneSubscriptionPlan: { route: 'subscriptionPlans/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        addSubscriptionPlan: { route: 'subscriptionPlans/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        removeSubscriptionPlan: { route: 'subscriptionPlans/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

        getAdditinalCreditsPlans: { route: 'additinalCreditsPlan/getAllPanel', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        getOneAdditinalCreditsPlan: { route: 'additinalCreditsPlan/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        addAdditinalCreditsPlan: { route: 'additinalCreditsPlan/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        removeAdditinalCreditsPlan: { route: 'additinalCreditsPlan/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        getAdditionalEquipmentPlans: { route: 'additionalEquipmentPlan/getAllPanel', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        getOneAdditionalEquipmentPlan: { route: 'additionalEquipmentPlan/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        addAdditionalEquipmentPlan: { route: 'additionalEquipmentPlan/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        removeAdditionalEquipmentPlan: { route: 'additionalEquipmentPlan/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        importAdditionalEquipmentDrafts: { route: 'additionalEquipmentPlan/importDrafts', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

        getSubscriptions: { route: 'subscriptions/getAllPanel', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        getOneSubscription: { route: 'subscriptions/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        addSubscription: { route: 'subscriptions/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        removeSubscription: { route: 'subscriptions/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

        getPaymentHistories: { route: 'paymentHistories/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        addPaymentHistory: { route: 'paymentHistories/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        removePaymentHistory: { route: 'paymentHistories/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

        getPaymentInvoices: { route: 'paymentHistories/getAllInvoices', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        addPaymentInvoices: { route: 'paymentHistories/addInvoice', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
        removePaymentInvoices: { route: 'paymentHistories/removeInvoice', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    getTickets: { route: 'ticketing/getTickets', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getRemovedTickets: { route: 'ticketing/getRemovedTickets', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getTicketsCount: { route: 'ticketing/getTicketsCount', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    changeTicketStatus: { route: 'ticketing/changeTicketStatus', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postTicketReply: { route: 'ticketing/postTicketReply', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postTicket: { route: 'ticketing/postTicket', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneTicket: { route: 'ticketing/getOneTicket', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneTicketRental: { route: 'ticketing/getOneTicketRental', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeTicket: { route: 'ticketing/removeTicket', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    restoreTicket: { route: 'ticketing/restoreTicket', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getMyTickets: { route: 'ticketing/getMyTickets', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    getAttributes: { route: 'attributes/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneAttribute: { route: 'attributes/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addAttribute: { route: 'attributes/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeAttribute: { route: 'attributes/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    
    addRentalFromSell: { route: 'equipments/addRentalFromSell', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addSellFromRental: { route: 'tradingEquipments/addSellFromRental', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    postTEquipments: { route: 'tradingEquipments/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    updateSellRentalId: { route: 'tradingEquipments/updateSellRentalId', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getAllTEquipments: { route: 'tradingEquipments/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getAllTEquipments: { route: 'tradingEquipments/findDuplicateEquipmentIds', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneTEquipments: { route: 'tradingEquipments/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeTEquipments: { route: 'tradingEquipments/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getBreakdowns: { route: 'breakdowns/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneBreakdown: { route: 'breakdowns/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addBreakdown: { route: 'breakdowns/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeBreakdown: { route: 'breakdowns/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    viewsGetAll: { route: 'users/viewsGetAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    getVouchers: { route: 'vouchers/getAllAdmin', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneVoucher: { route: 'vouchers/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addVoucher: { route: 'vouchers/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeVoucher: { route: 'vouchers/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getVouchersSubscription: { route: 'subscriptionVouchers/getAllAdmin', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneVoucherSubscription: { route: 'subscriptionVouchers/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addVoucherSubscription: { route: 'subscriptionVouchers/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeVoucherSubscription: { route: 'subscriptionVouchers/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getAddresses: { route: 'addresses/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getAllEmail: { route: 'emailsAndLoggers/getAllEmail', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getAllLogger: { route: 'emailsAndLoggers/getAllLogger', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // "migrator/updateEquipmentsWaterMark": { function: updateEquipmentsWaterMark, security: null, Response: { type: "json" }, },
    // "migrator/updateEquipmentsImagesWaterMark": { function: updateEquipmentsImagesWaterMark, security: null, Response: { type: "json" }, },
    // getPlaces: { route: 'migrator/updateEquipmentsAttrebutes', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/fixfinancialSnapShots', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/deleteAllRemovedUserPlaces', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/makeFinancialSnapShots', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, 
    // getPlaces: { route: 'migrator/fixRentalSnapShots', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/addAllCountriesAndStates', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/fixRentalOwners', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // getPlaces: { route: 'migrator/updateAllStates', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    
    // getPlaces: { route: 'migrator/makeSearchTitleSell', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'content/getCurrenciesAndUpdateMongo', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // getPlaces: { route: 'migrator/makeUserCategoriesSell', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/makeUserCategories', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/removeAllUserCats', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/removeAllUserPlaces', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/updateuseHomePage', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    getPlaces: { route: 'places/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },  //maaaaiiiiinnnnnnnnnnnnnn

    // getPlaces: { route: 'migrator/resetUsersWhatsAppCounts', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/updateBlogsActive', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/updateEquipmentsDelivery', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    
    // getPlaces: { route: 'exports/ExelAttributesMatrix', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // getPlaces: { route: 'migrator/regenerateSitemap', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/makeRandomRankingSell', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // getPlaces: { route: 'tradingEquipments/createIndexes', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },        
    

    // getPlaces: { route: 'migrator/makeRandomRankingSell', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/fixSuffixTranslations', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // getPlaces: { route: 'migrator/updateBlogAndUserBlogsSlug', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/findAndUpdateWebpWithNoWatermark', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/findAndUpdateWebpWithNoWatermarkBatch', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // getPlaces: { route: 'migrator/findBullshetExtentions', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/changeToWebpAndUpdateReferences', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/onlyWebpUpdateReferences', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/findBullshetExtentionsAndCopy', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/resizeWebPFilesInDirectories', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/findBullshetExtentionsBlogs', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    
    // getPlaces: { route: 'translate/json', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/updateSubscriptionPaymentMethods', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    
    
    // getPlaces: { route: 'migrator/changeToWebp', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/updateEquipments', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    // getPlaces: { route: 'migrator/updatetEqswebstoreImage', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, //! for images t
    // getPlaces: { route: 'migrator/updateEqswebstoreImage', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true }, //! for images
    
    // getPlaces: { route: 'migrator/makedescSell', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/updateUserSubDate', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/updateUserSubListing', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/sendEmail', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/updateWikiessAttrebutes', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    
    // getPlaces: { route: 'equipments/sendActivationEmail', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    // getPlaces: { route: 'migrator/updateEquipmentstempPLaces', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPlaces: { route: 'migrator/updateOneUsersWebstore', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getMapPlaces: { route: 'places/getMapPlaces', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addPlace: { route: 'places/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removePlace: { route: 'places/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    getMapCountries: { route: 'countries/getMapCountries', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    getEmployees: { route: 'employees/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addEmployee: { route: 'employees/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeEmployee: { route: 'employees/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getPermissions: { route: 'permissions/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addPermission: { route: 'permissions/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removePermission: { route: 'permissions/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getPermission: { route: 'permissions/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getIntroductions: { route: 'introductions/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneIntroduction: { route: 'introductions/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addIntroduction: { route: 'introductions/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeIntroduction: { route: 'introductions/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // insurances
    insurancesCreate: { route: 'insurances/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    insurancesGetAll: { route: 'insurances/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    insurancesGetOne: { route: 'insurances/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    insurancesRemove: { route: 'insurances/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // userBlogs
    userBlogsGetAll: { route: 'userBlogs/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userBlogsGetOne: { route: 'userBlogs/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userBlogsCreate: { route: 'userBlogs/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userBlogsRemove: { route: 'userBlogs/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
  

    // userFAQs
    userFAQsCreate: { route: 'userFAQs/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userFAQsGetAll: { route: 'userFAQs/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userFAQsRemove: { route: 'userFAQs/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // userAgreements
    userAgreementsCreate: { route: 'userAgreements/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userAgreementsGetAll: { route: 'userAgreements/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    userAgreementsRemove: { route: 'userAgreements/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

  
    // Antbuildz
    getAll: { route: 'values/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addValue: { route: 'values/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeValue: { route: 'values/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getValuesWithData: { route: 'values/getValuesWithData', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    postValue: { route: 'values/postValue', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // removeValue: { route: 'values/removeValue', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneFilter: { route: 'values/getOneFilter', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    sendInvoiceEmail: { route: 'financial/SendEmail', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    SendEmailLate1: { route: 'financial/SendEmailLate1', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    SendEmailLate2: { route: 'financial/SendEmailLate2', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    SendEmailLate3: { route: 'financial/SendEmailLate3', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    SendEmailLate4: { route: 'financial/SendEmailLate4', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    SendEmailLate5: { route: 'financial/SendEmailLate5', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getInvoicePDF: { route: 'financial/GetPdf', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOriginalInvoicePDF: { route: 'financial/GetOriginalPdf', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    GetInsurancePdf: { route: 'financial/GetInsurancePdf', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getInsurancePDF: { route: 'rentals/getInsuracePdf', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    submitImport: { route: 'imports/submitImport', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    userExcelExport: { route: 'exports/ExelUsers', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    financialExcelExport: { route: 'exports/ExelFinancial', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    rentalExcelExport: { route: 'exports/ExelRental', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    equipmentExcelExport: { route: 'exports/ExelEquipment', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    categoryExcelExport: { route: 'exports/categoryExcelExport', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    wikiExcelExport: { route: 'exports/ExelWikis', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    ExelTradingEquipment: { route: 'exports/ExelTradingEquipment', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    employeeSignin: { route: 'employees/authenticate', server: 'yc', hashMethod: '', params: [], auth: null, flexibleParams: true },
    updatePassword: { route: 'employees/updatePassword', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    updateInfo: { route: 'employees/updateInfo', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getUsers: { route: 'users/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getTenants: { route: 'tenants/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneTenant: { route: 'tenants/getOne', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    transferTenant: { route: 'tenants/transferOwnership', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getPostDeployMigrationStatus: { route: 'tenants/getPostDeployMigrationStatus', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getPostDeployContentChoices: { route: 'tenants/getPostDeployContentChoices', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getPostDeployRealmReview: { route: 'tenants/getPostDeployRealmReview', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    startPostDeployMigration: { route: 'tenants/startPostDeployMigration', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getStorefrontWorkerRouteStatus: { route: 'tenants/getStorefrontWorkerRouteStatus', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    syncStorefrontWorkerRoutes: { route: 'tenants/syncStorefrontWorkerRoutes', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    sendDedicatePlanReq: { route: 'users/sendDedicatePlanReq', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    sendDedicatePlanReqWithLink: { route: 'users/sendDedicatePlanReqWithLink', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    sendDedicatePlanReqUser: { route: 'users/sendDedicatePlanReqUser', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    sendDedicatePlanReqWithLinkUser: { route: 'users/sendDedicatePlanReqWithLinkUser', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getAdminAiBillingTenants: { route: 'users/getAdminAiBillingTenants', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getAdminAiBillingTenantList: { route: 'users/getAdminAiBillingTenantList', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneAdminAiBillingTenant: { route: 'users/getOneAdminAiBillingTenant', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneAdminWebStoreSubscriber: { route: 'users/getOneAdminWebStoreSubscriber', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    updateAdminAiBillingTenant: { route: 'users/updateAdminAiBillingTenant', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getAdminAiBillingSummary: { route: 'users/getAdminAiBillingSummary', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getAdminAiBillingLedger: { route: 'users/getAdminAiBillingLedger', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    grantAdminAiBillingCredits: { route: 'users/grantAdminAiBillingCredits', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    grantAllAdminAiBillingCredits: { route: 'users/grantAllAdminAiBillingCredits', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    setAllTenantsHeadStartCredits: { route: 'users/setAllTenantsHeadStartCredits', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    addUser: { route: 'users/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeUser: { route: 'users/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    financialCalander: { route: 'statistics/financialCalander', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    rentalCalander: { route: 'statistics/rentalCalander', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    financialReport: { route: 'statistics/financialReport', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    rentalsReport: { route: 'statistics/rentalsReport', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    usersReport: { route: 'statistics/usersReport', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    partnersReport: { route: 'statistics/partnersReport', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    listingReport: { route: 'statistics/listingReport', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    equipmentsReport: { route: 'statistics/equipmentsReport', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    salesReport: { route: 'statistics/salesReport', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    salesReportByPrice: { route: 'statistics/salesReportByPrice', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },





    // USER
    getOneUser: { route: 'users/getOneFilter', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    postUserIndicator: { route: 'users/signup/postUserIndicator', server: 'yc', hashMethod: '', params: [{ key: "userIndicator", type: 'string', required: true }, { key: "indicatorType", type: 'string', required: true }] },
    signupActicationCode: { route: 'users/signup/postActicationCode', server: 'yc', hashMethod: '', params: [{ key: "userIndicator", type: 'string', required: true }, { key: "code", type: 'number', required: true }, { key: "indicatorType", type: 'string', required: true }] },
    signinActicationCode: { route: 'users/signin/postActicationCode', server: 'yc', hashMethod: '', params: [{ key: "userIndicator", type: 'string', required: true }, { key: "code", type: 'number', required: true }, { key: "indicatorType", type: 'string', required: true }] },
    postUserInfo: { route: 'users/signup/postUserInfo', server: 'yc', hashMethod: '', flexibleParams: true, params: [{ key: "userIndicator", type: 'string', required: true }, { key: "code", type: 'number', required: true }, { key: "indicatorType", type: 'string', required: true }] },
    postForgotPassword: { route: 'users/signup/postForgotPassword', server: 'yc', hashMethod: '', params: [{ key: "userIndicator", type: 'string', required: true }, { key: "indicatorType", type: 'string', required: true }] },
    postPassword: { route: 'users/signup/postPassword', server: 'yc', hashMethod: '', params: [{ key: "userIndicator", type: 'string', required: true }, { key: "code", type: 'number', required: true }, { key: "password", type: 'string', required: true }, { key: "indicatorType", type: 'string', required: true }] },
    postNewPassword: { route: 'users/signup/postNewPassword', server: 'yc', hashMethod: '', params: [{ key: "userIndicator", type: 'string', required: true }, { key: "code", type: 'number', required: true }, { key: "password", type: 'string', required: true }, { key: "indicatorType", type: 'string', required: true }] },
    getUserInfo: { route: 'employees/getInfo', server: 'yc', hashMethod: '', auth: 'token', params: [] },
    // getOneUser: { route: 'users/getOneUser', server: 'yc', hashMethod: '', auth: 'token', params: [{ key: "id", type: 'string', required: true }] },
    updateUserInfo: { route: 'users/updateUserInfo', server: 'yc', hashMethod: '', flexibleParams: true, auth: 'token', params: [{ key: "name", type: 'string', required: true }, { key: "name", type: 'family', required: true }] },
    updateUserPassword: { route: 'users/updateUserPassword', server: 'yc', hashMethod: '', flexibleParams: true, auth: 'token', params: [{ key: "currentPassword", type: 'string', required: true }, { key: "newPassword", type: 'string', required: true }] },
    getInbox: { route: 'users/getInbox', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getInboxSub: { route: 'users/getInboxSub', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // removeSub: { route: 'subscriptionLogs/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    seenInbox: { route: 'users/seenInbox', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    tradingOrdersAdd: { route: 'tradingOrders/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    tradingOrdersAll: { route: 'tradingOrders/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    tradingOrdersRemove: { route: 'tradingOrders/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    
    rentalOrdersAdd: { route: 'rentalOrders/add', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    rentalOrdersAll: { route: 'rentalOrders/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    rentalOrdersRemove: { route: 'rentalOrders/remove', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },



    // getUsers: { route: 'users/getUsers', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // removeUser: { route: 'users/removeUser', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    updateUser: { route: 'users/updateUser', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getAdmins: { route: 'users/getAdmins', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    updateAdmin: { route: 'users/updateAdmin', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removeAdmin: { route: 'users/removeAdmin', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    getPayments: { route: 'payments/getPayments', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    updatePayment: { route: 'payments/updatePayment', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    removePayment: { route: 'payments/removePayment', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    increaseBalance: { route: 'payments/increaseBalance', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    usersExport: { route: 'users/usersExport', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    //THINGS
    postWiki: { route: 'things/postWiki', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getWiki: { route: 'things/getWiki', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getOneWiki: { route: 'things/getOneWiki', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    getGateways: { route: 'things/getGateways', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    //COUNTRIES
    countriesCreate: { route: "countries/add", server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    countriesGetAll: { route: "countries/getAll", server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    countriesGetOne: { route: "countries/getOne", server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    countriesRemove: { route: "countries/remove", server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    //languages
    languagesCreate: { route: "languages/add", server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    languagesGetAll: { route: "languages/getAll", server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    languagesGetOne: { route: "languages/getOne", server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    languagesRemove: { route: "languages/remove", server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },





    // getThings: { route: 'things/getThings', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getThingsAdmin: { route: 'things/getThingsAdmin', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getOneThing: { route: 'things/getOneThing', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postThing: { route: 'things/postThing', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // removeThing: { route: 'things/removeThing', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getMyThings: { route: 'things/getMyThings', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postTempThing: { route: 'things/postTempThing', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getCharactristics: { route: 'things/getCharactristics', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // changeThingStatus: { route: 'things/changeThingStatus', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    // getThingInfo: { route: 'receive/getThingInfo', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getThingHistory: { route: 'receive/getThingHistory', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getConnectedThings: { route: 'receive/getConnectedThings', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // postSubscribe: { route: 'connections/postSubscribe', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postUnsubscribe: { route: 'connections/postUnsubscribe', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // checkGatewayIntroStatus: { route: 'things/checkGatewayIntroStatus', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // postRigram: { route: 'applets/postRigram', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postDashboard: { route: 'dashboards/postDashboard', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getDashboards: { route: 'dashboards/getDashboards', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getMyDashboards: { route: 'dashboards/getMyDashboards', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getDashboard: { route: 'dashboards/getDashboard', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // removeDashboard: { route: 'dashboards/removeDashboard', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postUsersForThing: { route: 'things/postUsersForThing', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // togglePin: { route: 'dashboards/togglePin', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getPins: { route: 'dashboards/getPins', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    //APPLET
    // postApplet: { route: 'applets/postApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getMyApplets: { route: 'applets/getMyApplets', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getOneApplet: { route: 'applets/getOneApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // removeApplet: { route: 'applets/removeApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getAppletExtraInfo: { route: 'applets/getAppletExtraInfo', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getTriggers: { route: 'applets/getTriggers', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postActionTrigger: { route: 'receive/postActionTrigger', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postThingsForApplet: { route: 'applets/postThingsForApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // removeThingFormApplet: { route: 'applets/removeThingFormApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postGroup: { route: 'applets/postGroup', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // removeGroup: { route: 'applets/removeGroup', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getGroups: { route: 'applets/getGroups', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getAppletThings: { route: 'applets/getAppletThings', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postThingRoles: { route: 'applets/postThingRoles', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postUsersForApplet: { route: 'applets/postUsersForApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postUserRoles: { route: 'applets/postUserRoles', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // removeUserFormApplet: { route: 'applets/removeUserFormApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getSubscribedUsers: { route: 'applets/getSubscribedUsers', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },





    // TRADING

    // getAllTEquipments: { route: 'tradingEquipments/getAll', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getOneTEquipments: { route: 'trading/getOneTEquipments', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postTEquipments: { route: 'trading/postTEquipments', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // removeTEquipments: { route: 'trading/removeTEquipments', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // getAllTRequests: { route: 'trading/getAllTRequests', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // postTRequest: { route: 'trading/postTRequest', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // removeTRequest: { route: 'trading/removeTRequest', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },







    //Values


    // Younnect
    // ygetAppletByURL: { route: 'yapplets/getAppletByURL', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // ycreateProfile: { route: 'yprofiles/createProfile', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // checkUsernameValidity: { route: 'yprofiles/checkUsernameValidity', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getProfilesWithAddAppletPermission: { route: 'yprofiles/getProfilesWithAddAppletPermission', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // ycreateApplet: { route: 'yapplets/createApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getConnectedProfiles: { route: 'yprofiles/getConnectedProfiles', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getConnectedApplets: { route: 'yapplets/getConnectedApplets', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // ygetOneApplet: { route: 'yapplets/getOneApplet', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    // postInvoice: { route: 'yaccounting/postInvoice', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // getInvoices: { route: 'yaccounting/getInvoices', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // ypostProductCategory: { route: 'yproducts/postCategory', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // ygetProductsCategories: { route: 'yproducts/getCategories', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // ypostProduct: { route: 'yproducts/postProduct', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // ygetProducts: { route: 'yproducts/getProducts', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // yremoveProduct: { route: 'yproducts/removeProduct', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // yremoveExtraSection: { route: 'yaccounting/removeExtraSection', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // ygetExtraSections: { route: 'yaccounting/getExtraSections', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // ypostExtraSection: { route: 'yaccounting/postExtraSection', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },


    // // Y Connections
    // ygetConnections: { route: 'yconnections/getConnections', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // yaddConnection: { route: 'yconnections/addConnection', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // yeditConnection: { route: 'yconnections/editConnection', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // yremoveConnection: { route: 'yconnections/removeConnection', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // ygetConnectionGroups: { route: 'yconnections/getConnectionGroups', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // ypostConnectionGroup: { route: 'yconnections/postConnectionGroup', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // ypostConnectionGroup: { route: 'yconnections/postConnectionGroup', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },
    // yremoveConnectionGroup: { route: 'yconnections/removeConnectionGroup', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

    // ysearchUser: { route: 'yconnections/searchUser', server: 'yc', hashMethod: '', params: [], auth: 'token', flexibleParams: true },

}


export { siteConfig, siteTheme, languagesInfo, apisList,languagesInfoTranslate }
